import i18n from '@/libs/i18n'
import type { NavLink } from '@/types/Navigation'

const { t } = i18n.global

export const getNavItems = (): NavLink[] => {
    return [
        {
            items: [
                { label: t('general.dashboard'), icon: 'pi pi-fw pi-chart-bar', to: 'dashboard' },
                { label: t('admin_user.user', 2), icon: 'pi pi-fw pi-users', to: 'admin-users' },
                { label: t('user.user', 2), icon: 'pi pi-fw pi-user', to: 'users' },
                { label: t('task_type.task_type', 2), icon: 'pi pi-fw pi-bars', to: 'task-types' },
                { label: t('task.task', 2), icon: 'pi pi-fw pi-list', to: 'tasks' }
            ]
        }
    ]
}
